const config = {
  API_URL: window.apiGatewayEndPoint.apiUrl,
  IMAGE_URL: window.apiGatewayEndPoint.imageUrl,
  LOGO_URL: window.apiGatewayEndPoint.logoUrl,
  WEB_URL: window.apiGatewayEndPoint.webUrl
};

export default config;
